import React, { useState } from "react";
import Modal from "Common/Components/Modal";
import axios from "axios";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";
import { useQuestions } from "./useTrivia";
import QuestionBox from "./QuestionBox";

const Trivia = () => {
  const { questions, loading } = useQuestions();
  const [showModal, setShowModal] = useState(false);
  const [newQuestion, setNewQuestion] = useState({
    questionText: "",
    choices: ["", "", "", ""], // 4 default choices
    correctAnswers: [""],
  });

  // Handle input changes
  const handleInputChange = (e, index, field) => {
    const value = e.target.value;
    setNewQuestion((prev) => {
      const updated = { ...prev };
      if (field === "questionText") {
        updated.questionText = value;
      } else if (field === "choices") {
        updated.choices[index] = value;
      } else if (field === "correctAnswers") {
        updated.correctAnswers = [value];
      }
      return updated;
    });
  };

  // Submit new question
  const submitQuestion = async () => {
    try {
      await axios.post("/api/create-question", newQuestion);
      toast.success("Question added successfully!");
      setShowModal(false);
      window.location.reload(); // Refresh questions
    } catch (err) {
      toast.error("Error adding question.");
    }
  };

  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Trivia</h2>
        <button
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
          onClick={() => setShowModal(true)}
        >
          <Plus className="mr-2" /> Add Question
        </button>
      </div>

      {loading && <p>Loading...</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {questions?.map((question, index) => (
          <QuestionBox
            key={index}
            questionText={question.questionText}
            choices={question.choices}
            correctAnswers={question.correctAnswers}
          />
        ))}
      </div>

      {/* Modal for Adding Questions */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[32rem] bg-white shadow-lg rounded-md dark:bg-gray-800"
      >
        <Modal.Header className="flex items-center justify-between p-5 border-b dark:border-gray-600">
          <h2 className="text-xl font-bold text-gray-800 dark:text-white">
            Add New Question
          </h2>
        </Modal.Header>

        <Modal.Body className="p-6 space-y-5">
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Question Text
            </label>
            <input
              type="text"
              className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
              value={newQuestion.questionText}
              onChange={(e) => handleInputChange(e, null, "questionText")}
              placeholder="Enter question..."
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Choices
            </label>
            {newQuestion.choices.map((choice, index) => (
              <input
                key={index}
                type="text"
                className="w-full p-3 border border-gray-300 rounded-md mb-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                value={choice}
                placeholder={`Choice ${index + 1}`}
                onChange={(e) => handleInputChange(e, index, "choices")}
              />
            ))}
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Correct Answer
            </label>
            <input
              type="text"
              className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:outline-none"
              value={newQuestion.correctAnswers[0]}
              onChange={(e) => handleInputChange(e, 0, "correctAnswers")}
              placeholder="Enter correct answer..."
            />
          </div>
        </Modal.Body>

        <Modal.Footer className="p-5 flex justify-end space-x-4">
          <button
            className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-all"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all"
            onClick={submitQuestion}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Trivia;
